
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "Anal_neoplasm",
components: {
XTable
}
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/Anal_neoplasm.vue